module.exports = webappBundle("kpis/kpis.css");